import mainApi from "../../api/MainApi";
import { DEMO_PRODUCT } from "../constants";

export function constructor_parser(response, setConstants, shop_id) {
    console.log({ response })
    const { card, item_page, main_page, main_page_static, tokens, static_pages, social_networks, header_links, footer_links, using_filters, constants, deliveries, shop_payments } = response
    const { colour_data, font_data, shape_type, shape_type_size } = tokens
    const { background, neutral, primary, secondary, semantic_minus, semantic_plus } = colour_data
    const { font, fonts_list } = font_data
    const { caption, text, h1, h2, h3, h4 } = fonts_list
    mainApi
        .getCategories({
            limit: 25,
            shop_id: shop_id,
        })
        .then((res) => {
            const categories = res.data
            const platfromTokens = {
                logo: {
                    url: main_page.logo?.urls?.orig, // value = "https://files.polza.tech/image/id"
                },
                h1: {
                    weight: h1.weight,
                    size: h1.size,
                },
                h2: {
                    weight: h2.weight,
                    size: h2.size,
                },
                h3: {
                    weight: h3.weight,
                    size: h3.size,
                },
                h4: {
                    weight: h4.weight,
                    size: h4.size,
                },
                text: {
                    weight: text.weight,
                    size: text.size,
                },
                caption: {
                    weight: caption.weight,
                    size: caption.size,
                },
                font_family: {
                    name: font.name,
                    link: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap', // value 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap'
                },
                color_kit: {
                    primary: {
                        active: primary.active,
                        selection: primary.selection,
                        background: primary.background,
                    },
                    secondary: {
                        active: secondary.active,
                        selection: secondary.selection,
                        background: secondary.background,
                    },
                    semantic_plus: {
                        active: semantic_plus.active,
                        selection: semantic_plus.selection,
                        background: semantic_plus.background,
                    },
                    semantic_minus: {
                        active: semantic_minus.active,
                        selection: semantic_minus.selection,
                        background: semantic_minus.background,
                    },
                    neutral: {
                        active: neutral.active,
                        selection: neutral.selection,
                        background: neutral.background,
                    },
                    website_background: {
                        active: background,
                    },
                },
                initial_border_radius: {
                    type: shape_type,
                    value: shape_type_size,
                },
            };


            const cardTokens = {
                cards_in_line: card.card_in_line,
                image_format: card.image.format,
                image_radius: `${card.image.radius}px`,
                price_format: card.price.format,
                but_btn_format: card.price.buy_btn,
                layout: card.order.map((item) => {
                    return {
                        type: item,
                    }
                }),
            }

            const productPageTokens = {
                photo_gallery: item_page.photo_gallery,
            }


            const initialConstants = {
                SHOP_NAME: 'Sanywatches',
                SHOP_ID_FOR_API: shop_id, // value 'CURRENT SHOP ID FOR AUTHORIZE API REQUESTS'
                FIRST_LEVEL_CATEGORIES: categories, // value [ARRAY OF CATEGORIES ON FIRST LEVEL BY THIS SHOP ID]
                ROOT_PATH: '{{ROOT_PATH}}', // value 'ROOT_PATH' like shops.polza.tech/test-shop where "test-shop" is value
                STATIC_PAGES: static_pages,
                SOCIAL_NETWORKS: social_networks,
                HEADER_LINKS: header_links,
                FOOTER_LINKS: footer_links,
                USING_FILTERS: using_filters,
                CONSTANTS: constants,
                DELIVERIES: deliveries,
                SHOP_PAYMENTS: shop_payments,
            }

            const mainLayout = main_page_static.data.map((item) => {
                return {
                    type: item.block.type,
                    data: item.data,
                }
            })



            const rootStyle = document.documentElement.style;
            rootStyle.setProperty('--font-family', platfromTokens.font_family.name);
            rootStyle.setProperty(`--primary-active`, primary.active);
            rootStyle.setProperty(`--primary-selection`, primary.selection);
            rootStyle.setProperty(`--primary-background`, primary.background);
            rootStyle.setProperty(`--secondary-active`, secondary.active);
            rootStyle.setProperty(`--secondary-selection`, secondary.selection);
            rootStyle.setProperty(`--secondary-background`, secondary.background);
            rootStyle.setProperty(`--semantic_plus-active`, semantic_plus.active);
            rootStyle.setProperty(`--semantic_plus-selection`, semantic_plus.selection);
            rootStyle.setProperty(`--semantic_plus-background`, semantic_plus.background);
            rootStyle.setProperty(`--semantic_minus-active`, semantic_minus.active);
            rootStyle.setProperty(`--semantic_minus-selection`, semantic_minus.selection);
            rootStyle.setProperty(`--semantic_minus-background`, semantic_minus.background);
            rootStyle.setProperty(`--neutral-active`, neutral.active);
            rootStyle.setProperty(`--neutral-selection`, neutral.selection);
            rootStyle.setProperty(`--neutral-background`, neutral.background);
            rootStyle.setProperty(`--website_background-background`, background);
            rootStyle.setProperty('--initial_border_radius-value', shape_type_size);
            rootStyle.setProperty(`--h1-weight`, h1.weight);
            rootStyle.setProperty(`--h1-size`, h1.size + 'px');
            rootStyle.setProperty(`--h2-weight`, h2.weight);
            rootStyle.setProperty(`--h2-size`, h2.size + 'px');
            rootStyle.setProperty(`--h3-weight`, h3.weight);
            rootStyle.setProperty(`--h3-size`, h3.size + 'px');
            rootStyle.setProperty(`--h4-weight`, h4.weight);
            rootStyle.setProperty(`--h4-size`, h4.size + 'px');
            rootStyle.setProperty(`--text-weight`, text.weight);
            rootStyle.setProperty(`--text-size`, text.size + 'px');
            rootStyle.setProperty(`--caption-weight`, caption.weight);
            rootStyle.setProperty(`--caption-size`, caption.size + 'px');
            console.log({
                mainLayout: mainLayout,
            })
            setConstants({
                initialConstants: initialConstants,
                productPageTokens: productPageTokens,
                cardTokens: cardTokens,
                mainLayout: mainLayout,
                platfromTokens: platfromTokens,
            })
        })
        .catch((err) => {
            console.log(err);
        });

}